import type { TemplateEditingMetadataType } from '@/data/schemas';

export type EditingState = 'editable' | 'locked' | 'computed';

interface ResolvedEditing {
  state: EditingState;
  reason?: string;
}

export function resolveSectionEditingState(section?: TemplateEditingMetadataType): ResolvedEditing {
  if (section?.state) {
    if (section.state === 'locked') {
      return { state: 'editable' };
    }
    return { state: section.state, reason: section.reason };
  }
  return { state: 'editable' };
}

export function resolveRowEditingState(
  section?: TemplateEditingMetadataType,
  row?: TemplateEditingMetadataType
): ResolvedEditing {
  if (row?.state) {
    return { state: row.state, reason: row.reason };
  }
  return resolveSectionEditingState(section);
}

export function resolveFieldEditingState({
  section,
  row,
  field,
  hasSource,
}: {
  section?: TemplateEditingMetadataType;
  row?: TemplateEditingMetadataType;
  field?: TemplateEditingMetadataType;
  hasSource: boolean;
}): ResolvedEditing {
  if (field?.state) {
    return { state: field.state, reason: field.reason };
  }
  if (row?.state) {
    return { state: row.state, reason: row.reason };
  }
  if (hasSource) {
    return { state: 'computed' };
  }
  if (section?.state) {
    return { state: section.state, reason: section.reason };
  }
  return { state: 'editable' };
}
